export default function moneyFormatter(amount, currency = '$', decimals = 0) {
  let value;

  amount = parseFloat(amount);
  value = amount.toFixed(decimals);
  value = parseFloat(value);

  value = value.toLocaleString();
  return `${currency}${value}`;
}

function getParamValue(str, obj) {
  let value = str;

  if (str.indexOf('[') !== -1) {
    const keyName = str.replace('[', '').replace(']', '');
    value = obj[keyName.toLowerCase()];
  }
  return value;
}

export function slugify(str) {
  return str.toLowerCase().replace(/ /g, '-');
}

export function getQueryString(paramObj, dataObj) {
  let qStr = '';

  if (paramObj && Object.keys(paramObj).length > 0) {
    qStr = '?';

    Object.keys(paramObj).forEach((param) => {
      const value = getParamValue(paramObj[param], dataObj);

      if (value) {
        qStr += `${param}=${value}&`;
      }
    });

    qStr = qStr.slice(0, -1);
  }

  return qStr;
}
